/**
 * @generated SignedSource<<9c5f9b69a7813d6dcb90410dfa87ee67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording$data = {
  readonly ownerAccount: {
    readonly __typename: string;
  };
  readonly transcript: any | null;
  readonly " $fragmentType": "TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording";
};
export type TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording$key = {
  readonly " $data"?: TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcript",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MeetingRecordingInterface",
  "abstractKey": "__isMeetingRecordingInterface"
};

(node as any).hash = "ad657f5011389b9cd1da975391c38a48";

export default node;
